import React from 'react';
import PropTypes from 'prop-types';
import {Option} from './Option';
import './style.scss';

/**
 * OptionListing :  DesignSection Component that list all  options associated
 * with a DesignSlide DragDrop Step
 */
function OptionsListing(props) {
  let className = props.optionType.toLowerCase();

  const renderOptionNode = (optionProps) =>
    React.cloneElement(props.option, {
      key: optionProps.id,
      optionId: optionProps.id,
      type: optionProps.type,
      optionDisabled: optionProps.optionDisabled ?? false,
      optionProps,
    });

  if (props.option) {
    return (
      <div className={`optionListing optionListing_${className}`}>
        {props.optionsList.map(renderOptionNode)}
      </div>
    );
  } else {
    return null;
  }
}

OptionsListing.propTypes = {
  /**
   * React Component that render single Option.
   */
  option: PropTypes.element.isRequired,
  /**
   * List of Option Items to be listed
   */
  optionsList: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * Type of option component
   */
  optionType: PropTypes.string.isRequired,
};

OptionsListing.defaultProps = {
  optionsList: [],
};

export {OptionsListing, Option};
